import defaultVehicle from "@/views/Pages/VehiclesModule/VehicleManagement/defaultVehicle";

export default {
  type: "repairs",
  excerpt: "",
  work_order: "",
  odometer: 0,
  relationshipNames: [
    "organization",
    "customer",
    "approver",
    "vehicle",
    "inspection",
    "estimation",
    "allowedLocations",
  ],
  vehicle: defaultVehicle,
  organization: {
    type: "organizations",
    id: null,
  },
  customer: {
    type: "customers",
    id: null,
  },
  approver: {
    type: "users",
    id: null,
  },
  inspection: {
    type: "inspections",
    id: null,
  },
  estimation: {
    type: "estimations",
    id: null,
  },
  allowedLocations: [],
};
